import { get } from 'svelte/store';
import { currentScreen as svelteCurrentScreen, activeMatch, peerRole } from './svelte/store.js';
import { resolveDeviceRoute } from './device-session.js';
import { isInningsOver } from './scoring-logic.js';
import { selectInitialScreen } from './session-storage.js';

let currentScreenHash = null;

export function initRouter() {
  window.addEventListener('hashchange', handleHashChange);
  handleHashChange();
  svelteCurrentScreen.subscribe(val => {
    if (val !== currentScreenHash) {
      window.location.hash = val;
    }
  });
}

export function go(screen) {
  window.location.hash = screen;
}

function handleHashChange() {
  const requested = window.location.hash.replace('#', '') || 'home';
  const routeMatch = get(activeMatch);
  const deviceRoute = resolveDeviceRoute(requested, routeMatch, get(peerRole));
  const hash = selectInitialScreen({
    requested: deviceRoute,
    match: routeMatch,
    role: get(peerRole),
    inningsOver: !!routeMatch && isInningsOver(routeMatch)
  });
  if (hash !== requested) {
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}#${hash}`);
  }
  currentScreenHash = hash;
  svelteCurrentScreen.set(hash);
  activeMatch.set(get(activeMatch)); // Trigger updates if needed
}
